import { Component, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { AuthenticationService } from "src/app/_app-core/services/authenticationService";

@Component({
    selector: "app-impersonate",
    templateUrl: "./impersonate.component.html",
    styleUrls: ["./impersonate.component.scss"],
})
export class ImpersonateComponent implements OnInit {
    sessionId: any;
    code: any;
    adminName: any;
    adminEmail: any;
    responseData;
    sellerCode: any;
    constructor(
        private router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,
        private authService: AuthService,
        private authenticationService: AuthenticationService
    ) {
        this.route.queryParams.subscribe((params) => {
            if (params["token"]) {
                const pathParams = params["token"];
                let pathSplit = pathParams.split("$$$");
                this.sessionId = pathSplit[0];
                this.code = pathSplit[1];
                this.adminName = pathSplit[2];
                this.adminEmail = pathSplit[3];
                this.sellerCode = pathSplit[4];
            } else {
                this.router.navigateByUrl("/");
            }
        });
    }

    private saveToken(
        eippSession: string,
        sessionId: string,
        name: string,
        vendor: string,
        sellerCode: string,
        nonPo_flag: string,
        logistics_flag: string,
        contact: string | number,
        vendorEmail: string
    ) {
        localStorage.setItem("eippSession", eippSession);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("displayName", name);
        localStorage.setItem("vendorCode", vendor);
        localStorage.setItem("contact", String(contact ?? ""));
        localStorage.setItem("sellerCode", sellerCode);
        localStorage.setItem("logisticFlag", logistics_flag);
        localStorage.setItem("nonPoFlag", nonPo_flag);
        localStorage.setItem("vendorEmail", vendorEmail ?? "");
    }

    ngOnInit(): void {
        const reqData = {
            supplierCode: this.code,
            session: {
                sessionId: this.sessionId,
            },
            sellerCode : this.sellerCode
        };
        this.authService.impersonate(reqData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.success) {
                    const user = this.responseData.data.user;
                    const vendorCode = user.eippSession.username;
                    const eippSession = user.eippSession.sessionId;
                    const sessionId = this.responseData.data.session.sessionId;
                    const displayName = user.displayName;
                    const sellerCode = user.sellerCode;
                    const nonPoFlag = user.eippSessionData.data.user.nonPoFlag;
                    const logisticFlag = user.eippSessionData.data.user.logisticsFlag;
                    const contact = user.eippSessionData.data.user.mobile;
                    const vendorEmail = user.eippSessionData.data.user.email;
                    this.saveToken(
                        eippSession,
                        sessionId,
                        displayName,
                        vendorCode,
                        sellerCode,
                        nonPoFlag,
                        logisticFlag,
                        contact,
                        vendorEmail
                    );
                    this.authService.setCurrentUser(user);
                    this.authenticationService.setCurrentUser(user);
                    localStorage.setItem("impersonation", "true");
                    localStorage.setItem("adminUser", this.adminName);
                    localStorage.setItem("adminEmail", this.adminEmail);
                    if (user.eippSessionData.data.user.enforcePasswordChange) {
                        this.router.navigateByUrl("/vendor-master-data");
                    } else {
                        this.router.navigateByUrl("/dashboard");
                    }
                }
            },
            (error) => {}
        );
    }
}
